import type {
    FeatureTogglesControllerGetAllFeatureTogglesQueryParams
} from "@/global/api/gen/ts/Feature TogglesDTO/FeatureTogglesControllerGetAllFeatureToggles";

export const FeatureTogglesKeys = {
    all: ['feature-toggles'] as const,
    detail: (moduleName:string) => [FeatureTogglesKeys.all, 'module', moduleName ] as const,
    search: () => [...FeatureTogglesKeys.all, 'search'] as const,
    searchWithParams: (params: FeatureTogglesControllerGetAllFeatureTogglesQueryParams) => [...FeatureTogglesKeys.search(), params] as const,
};